import {weakMemo} from '@packages/utilities/memo';
import {Plugins, VariableMap, EvalEnv} from '@packages/systems/wfdl';
import {identifier, qualify} from '@packages/systems/wfdl-Qualified';
import {type Environment} from '@packages/systems/core-constants';
import {USYS_ACCESS_TYPES} from '@packages/systems/users/constants';
import {brickedComputeIsUserLoggedIn} from '@packages/systems/users/utils/universalUtils';
import {type ComponentLocalizationMap} from '@packages/domains/localization/dom/model';
import {evaluateComponentLocalizations} from '@packages/domains/localization/render';
import type {
  ModalTargetContext,
  PopoverTargetContext,
} from '@packages/systems/overlays';

export const getContextEnvValues = (runtimeEnvironment: Environment) =>
  weakMemo((plugins: Plugins.PluginsType) =>
    weakMemo((componentLocalizationMap: ComponentLocalizationMap) => {
      const env = Plugins.getEvalEnv(plugins);

      const computeIsInAccessGroup = VariableMap.getPlugins(
        EvalEnv.getValues(env)
      ).get(
        qualify(Plugins.name('Users'), identifier('computeIsInAccessGroup'))
      );

      // Always render everything within the Designer / Editor
      const componentContext = {
        runtimeEnvironment,
        isUserLoggedIn: brickedComputeIsUserLoggedIn([
          USYS_ACCESS_TYPES.ADMIN_ALWAYS_VISIBLE,
        ]),
        isInAccessGroup: computeIsInAccessGroup
          ? computeIsInAccessGroup([USYS_ACCESS_TYPES.ADMIN_ALWAYS_VISIBLE])
          : false,
        localizations: evaluateComponentLocalizations(plugins)(
          componentLocalizationMap
        ),
      };

      return weakMemo((popoverTarget: PopoverTargetContext) =>
        weakMemo((modalTarget: ModalTargetContext) => ({
          ...componentContext,
          popoverTarget,
          modalTarget,
        }))
      );
    })
  );
